import Button from "../../atoms/button";
import { cn } from "../../../lib/utils/cn";
import type { CalendarItem } from "../../../@apis/dto/response/torunament.response";
import { formatDate } from "../../../lib/utils/dateUtils";
import { unavailableScheduleMessage } from "../../../lib/utils/tournamentUtils";
import { useMyInfoStore } from "../../../lib/store/useMyInfoStore";

interface CompetitionDateGroupScreenProps {
  calendarList: CalendarItem[];
  selectedDate: string;
  onSelectDate: (date: string) => void;
}

export default function CompetitionDateGroupScreen({
  calendarList,
  selectedDate,
  onSelectDate,
}: CompetitionDateGroupScreenProps) {
  const { myInfo } = useMyInfoStore();
  // depth2 의 calendarList 는 날짜당 1건(date + isFull)이 원칙 — isFull=true 면 그 날짜의 모든 일정이
  // 마감(정원 또는 회차 접수 마감)이라 선택 불가. 중복/필드 누락 방어: isFull 이 true 로 확인된
  // 항목만 마감으로 세어, 하나라도 열려 있거나 판정 불가면 선택 가능(fail-open)으로 본다.
  const dateEntries = Array.from(
    calendarList
      .reduce((acc, item) => {
        acc.set(item.date, (acc.get(item.date) ?? true) && item.isFull);
        return acc;
      }, new Map<string, boolean>())
      .entries(),
  );

  return (
    <section>
      <h1 className="font-semibold  mb-[36px]">
        참가하실 대회 날짜를 선택해 주세요.
      </h1>

      {dateEntries.length === 0 ? (
        <p className="text-sm font-medium text-[#8e8e93] break-keep">
          {unavailableScheduleMessage(myInfo.gender)}
        </p>
      ) : (
      <div className="space-y-[12px]">
        {dateEntries.map(([date, full]) => (
          <Button
            key={date}
            className={cn(
              "py-[12px] px-[20px] w-full",
              selectedDate === date && "border-1 border-black",
              full && "bg-[#f2f2f7] cursor-not-allowed",
            )}
            variant={"white"}
            label=""
            onClick={() => {
              if (full) return;
              onSelectDate(date);
            }}
          >
            <div
              className={cn(
                "flex gap-x-[8px] w-full items-center",
                full && "opacity-30",
              )}
            >
              <img src="/icons/ic-calendar.webp" className="size-5" />

              <p className="text-sm font-medium whitespace-pre-wrap break-words flex w-full gap-x-[8px] items-center">
                {formatDate(date, "MM월 DD일 (ddd)")}
              </p>
            </div>
          </Button>
        ))}
      </div>
      )}
    </section>
  );
}
